/* =================== BLOCOS HOME =================== */
$(function () {
  $(".carrosel-blocos").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          autoplay: false,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          autoplay: false,
          adaptiveHeight: true,
        },
      },
    ],
  });

  // Cancela o evento de click nos blocos sem link
  $('.bloco-item[href="#"]').on("click", function (ev) {
    ev.preventDefault();
  });
});
